import {LANGUAGE_TOKEN, LANGUAGE_TOKENS} from "../redux/slice/languageSlice";

export default function tryGetLanguageTokenFromString(token: string): LANGUAGE_TOKEN |undefined {
    if(!token){
        return undefined;
    }

    const isValid = LANGUAGE_TOKENS.includes(token.toUpperCase());
    return isValid ? token.toUpperCase() as LANGUAGE_TOKEN : undefined;
}
